import { render } from "./StockTransfer.vue?vue&type=template&id=db1dbea2&scoped=true&ts=true"
import script from "./StockTransfer.vue?vue&type=script&lang=ts"
export * from "./StockTransfer.vue?vue&type=script&lang=ts"

import "./StockTransfer.vue?vue&type=style&index=0&id=db1dbea2&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db1dbea2"]])

export default __exports__